import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { getAllUsers } from '../../../services/users/users.slice'
import { validators } from '../../../utils/helpers/validators'
import SaveButton from '../buttons/SaveButton'
import DropdownComp from '../form-components/dropdown/DropdownComp'

const AddUserFromModal = ({ handleAddUser }) => {
  const { formatMessage: msg } = useIntl()
  const dispatch = useDispatch()

  const users = useSelector((state) => state.users)

  const [user, setUser] = useState('')

  useEffect(() => {
    dispatch(getAllUsers({}))
  }, [])

  const onChange = ({ target: { value } }) => {
    setUser(value)
  }

  return (
    <div className="add-user-form">
      <div className="flex-container">
        <div className="control-label">Usuario</div>
        <div className="control-input">
          <DropdownComp
            value={user}
            options={users?.resp || []}
            name="users"
            optionLabel="name"
            optionValue="_id"
            onChange={onChange}
            placeholder={msg({ id: 'users' })}
          />
        </div>
      </div>

      <div className="modal-btn-container mt__1">
        <SaveButton
          btnClass="btn-save-modal"
          onClick={() => handleAddUser(user)}
          isDisabled={!validators.hasValue(user)}
        />
      </div>
    </div>
  )
}

export default AddUserFromModal
